// import { platformFee } from "../../constant/constant";
import { device_types_list, payment_type_card, payment_type_cash } from "../../constant/constant";
import { DELIVERY_STATUS, IsNullUndefine, ReturnItemCorrectPrice, getCurrentDate, getCurrentTime } from "../helper";
import Konsole from "../konsole/Konsole";
import ParseFloatPayment from "../ParseFlotPayment";
export const paymentElementOptions = {
  // paymentMethodOrder: ["apple_pay", "google_pay", "card", "klarna",'cash'],
  paymentMethodOrder: ["upi", "card", "google_pay", "apple_pay", "klarna", "sepa_debit", "ideal", "giropay"]
};
export const Payment = {
  CASH: payment_type_cash,
  CARD: payment_type_card,
};


export function saveOrderJson(reduxData: any, useAllCharges: any, stripeId: any, paymentOption: any, is_saved_card?: any) {
  // Konsole.log('reduxData', reduxData);
  const [taxes, discount, service_charge, remaining_amount, totalPrice, totalPriceNotUsed, deliveryChargeNotUsed, card_fees,round_off] = useAllCharges;

  const {
    checkoutAddress: {
      selectedAddress: { latitude, lattitude, longitude, full_address, house_no, zip_code, id, street_name },

      selectedPickupDate: { date, day },
      selectedPickupTime, deliveryScheduleType, deliveryInstruction, deliveryNotes },
    store: {selectedStore, selectedType },
    cartData: { commissionFee, deliveryCharge, discountAmount, items, itemCount },
    userData: { user: { first_name, last_name, iso_code, phone, phone_code, email } },
    commonData: { loader }
  } = reduxData;


  //  return true if select delivery else return false for pickup
  const isDeliverySelect = selectedType == DELIVERY_STATUS;
  // @@ true if select ASAP
  const isAsap = (deliveryScheduleType == 1 && IsNullUndefine(reduxData?.checkoutAddress?.selectedPickupDate))


  const data: any = {};

  data["first_name"] = first_name;
  data["last_name"] = last_name;
  data["name"] = `${first_name} ${last_name}`;
  data["email"] = email;
  data["phone"] = phone;
  data["iso_code"] = iso_code ? iso_code : "GB";
  data["phone_code"] = phone_code;
  data["ip_address"] = "0.0.0.0";


  // data["stripe_id"] = sessionStorage.getItem('secret_key_intent') || "";

  data["stripe_id"] = stripeId || "";
  data["commission"] = (commissionFee || 0);
  data["discountAmount"] = discountAmount || 0;
  data["currency"] = "SAR";
  data["final_price"] = totalPrice || 0;
  data["remaning_amount"] = remaining_amount || 0;
  data["sub_total"] = taxes?.sub_total || 0;
  data['platform_fee']=(selectedStore?.domain_setting?.platform_fee || 0);
  data["total_price"] = totalPrice || 0;
  data["total_tax"] = taxes?.tax_amount || 0;
  // data["payment_option"] = "card"; 
  data["payment_option"] = paymentOption || payment_type_card;
  data['is_saved_card'] = is_saved_card || false
  data["service_charge"] = (service_charge || 0) + (card_fees || 0);
  data["upi_method"] = paymentOption || ""
  data["delivery_address"] = isDeliverySelect ? full_address : '';
  data["round_off"]=round_off  || 0;

  // data['id'] = sessionStorage.getItem('secret_key_intent') || ""

  data['id'] = stripeId || "";

  // @@ address if select delivery
  // if (isDeliverySelect) {
  data["address_lat"] = isDeliverySelect ? (latitude || lattitude) : '';
  data["address_long"] = isDeliverySelect ? longitude : "";
  data["complete_address"] = isDeliverySelect ? full_address : '';
  data["delivery_charges"] = isDeliverySelect ? deliveryCharge : null;
  data["house_no"] = isDeliverySelect ? house_no : '';
  data["near_land_mark"] = "";
  data["street_name"] = street_name || '';
  data["zip_code"] = zip_code || "";
  // }


  data["store_status"] = 3;
  data["store_type"] = 3;
  data["device_type"] = device_types_list.web;
  data["order_category"] = selectedType;  // 1 or 3 for delivery and pickup
  data["is_asap"] = isAsap ? 1 : 2; // 1 or 2 for asap or schedule
  data["order_comments"] = isDeliverySelect ? deliveryInstruction : '';
  data['order_note'] = deliveryNotes;
  data["pre_order_status"] = 0;
  data["quantity"] = itemCount;
  data["items"] = onSaveOrderJsonUpdateItemPrice(items);
  data["selectedDate"] = isAsap ? getCurrentDate() : `${day} ${date}`;
  // data['selectedDate'] = ''
  data["time"] = isAsap ? getCurrentTime() : selectedPickupTime;


  return data;

}

export function onSaveOrderJsonUpdateItemPrice(items: any) {
  return items?.map((it: any, index: number) => {
    // console.log("_it", it)
    let selectedVariation = it?.selected_variation
    if (selectedVariation) {
      // web_price
      // let web_price=ReturnItemCorrectPrice(selectedVariation.web_price, it.tax_rate_list);
      // console.log('_web_price',web_price)
      selectedVariation = {
        ...selectedVariation,
        // web_price:SeprateTaxCalculate(selectedVariation.web_price,it.tax_rate_list)
        web_price: ReturnItemCorrectPrice(selectedVariation.web_price, it.tax_rate_list, it?.quantity)
      }
    }
    // console.log('_selectedVariation', selectedVariation)
    return {
      ...it,
      price: ReturnItemCorrectPrice(it.price, it.tax_rate_list, it?.quantity),
      selected_variation: selectedVariation
    }
  });
}


export function RazorPayCreateOrderJson(reduxData: any, useAllCharges: any, order_item_id: any) {
  const [
    taxes,
    discount,
    service_charge,
    remaining_amount,
    totalPrice,
    totalPrice_not_used,
    deliveryCharge_notused,
    card_fees,
     round_off,
    merchantFee
  ] = useAllCharges;

  const {
    store: { selectedStore },
    cartData: { commissionFee, deliveryCharge, discountAmount, items, itemCount },
  } = reduxData;

  // console.log("_commissionFee", commissionFee)
  // console.log('_selectedStore',selectedStore?.domain_setting?.platform_fee)
  return {
    store_id: selectedStore?.store_id ?? "",
    total_amount: ParseFloatPayment(totalPrice) ?? "",
    // store_amount: ParseFloatPayment(totalPrice - commissionFee - card_fees-(merchantFee || 0)) ?? "",
    platform_fee:(selectedStore?.domain_setting?.platform_fee || 0),
    order_item_id: order_item_id ? order_item_id : ""
  }
}